import React, { useEffect, useState, useCallback } from 'react';
import './styles.css';

const API_URL = 'https://5mlntupy9d.execute-api.us-east-1.amazonaws.com/prod/report';

const columns = [
  'ORG ID',
  'Username',
  'Email',
  'Group',
  'Permission Set',
  'Account ID',
];

function removeAccents(str) {
  return str.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

const OrgWidePermissionsTable = () => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ orgId: '', email: '', group: '' });
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    fetch(API_URL)
      .then(response => response.json())
      .then(result => {
        const arrayData = Array.isArray(result.body) ? result.body : JSON.parse(result.body);
        setData(arrayData);
        setFilteredData(arrayData);
      })
      .catch(console.error);
  }, []);

  const applyFilters = useCallback(() => {
    setFilteredData(
      data.filter(item => {
        const orgIdValue = (item['ORG-ID'] || item['ORG ID'] || item.orgId || item.Cedula || '').toString();
        const emailValue = (item.Email || item['Correo Electronico'] || '').toString();
        const groupValue = (item.Group || '').toString();
        const matchesOrgId = removeAccents(orgIdValue.toLowerCase()).includes(removeAccents(filters.orgId.toLowerCase()));
        const matchesEmail = removeAccents(emailValue.toLowerCase()).includes(removeAccents(filters.email.toLowerCase()));
        const matchesGroup = removeAccents(groupValue.toLowerCase()).includes(removeAccents(filters.group.toLowerCase()));
        return matchesOrgId && matchesEmail && matchesGroup;
      })
    );
  }, [data, filters]);

  useEffect(() => {
    applyFilters();
  }, [filters, data, applyFilters]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFilters(f => ({ ...f, [name]: value }));
  };

  return (
    <>
      <header className="main-header">
        <div className="header-content">
          <div className="header-logo">
            <img src="/images/logo-center-top.webp" alt="Logo" />
          </div>
        </div>
      </header>
      <div className="container">
        <h1>Org-wide Permissions</h1>
        <div style={{ marginBottom: 16 }}>
          <input
            type="text"
            name="orgId"
            id="orgIdFilter"
            placeholder="Buscar por ORG ID"
            value={filters.orgId}
            onChange={handleInputChange}
            style={{ marginRight: 8 }}
          />
          <input
            type="text"
            name="email"
            id="emailFilter"
            placeholder="Buscar por email"
            value={filters.email}
            onChange={handleInputChange}
            style={{ marginRight: 8 }}
          />
          <input
            type="text"
            name="group"
            id="groupFilter"
            placeholder="Buscar por group"
            value={filters.group}
            onChange={handleInputChange}
            style={{ width: 160 }}
          />
        </div>
        <table id="applicantTable" className="display">
          <thead>
            <tr>
              {columns.map(col => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, idx) => {
              const orgId = item['ORG-ID'] || item['ORG ID'] || item.orgId || item.Cedula;
              const username = item.Username || item.Nombre;
              const email = item.Email || item['Correo Electronico'];
              const group = item.Group || '';
              const permissionSet = item['Permission Set'] || item.PermissionSet || '';
              const accountId = item['Account ID'] || item.AccountId || '';
              return (
                <tr key={idx}>
                  <td>{orgId}</td>
                  <td>{username}</td>
                  <td>{email}</td>
                  <td>{group}</td>
                  <td>{permissionSet}</td>
                  <td>{accountId}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-left">Version 1.0</div>
          <div className="footer-center">© 2025 Blend360 Latam</div>
          <div className="footer-image">
            <img src="/images/logo-center-top.webp" alt="Logo" />
          </div>
        </div>
      </footer>
    </>
  );
};

export default OrgWidePermissionsTable; 